import { useEffect } from "react";
import { Route, BrowserRouter, Routes, Navigate } from "react-router-dom";

import './App.css';
import './dark-theme.css';
import Home from "./pages/Home";
import Events from "./pages/Events";
import Clients from "./pages/Clients";
import { ScrollProgress, LuxeIntro } from "./motion";

function App() {
  useEffect(() => {
    document.body.classList.add("hma-dark");
    return () => document.body.classList.remove("hma-dark");
  }, []);

  return (
    <BrowserRouter>
      <LuxeIntro brand="HMA" tagline="ULTIMATE EXCELLENCY" />
      <ScrollProgress />
      <Routes>
        <Route exact path={`${process.env.PUBLIC_URL + "/"}`} element={<Home />} />
        <Route exact path={`${process.env.PUBLIC_URL + "/events"}`} element={<Events />} />
        <Route exact path={`${process.env.PUBLIC_URL + "/clients"}`} element={<Clients />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
